"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EventValidator = void 0;
var _BaseValidator = require("../BaseValidator/BaseValidator");
var EventValidator = exports.EventValidator = {
  title: _BaseValidator.title
};